// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2FdA5","error":"Textarea_error__2xEuh","readonly":"Textarea_readonly__MXSRw","disabled":"Textarea_disabled__4uGcA"};